module.exports = __webpack_public_path__ + "static/img/heroimage_send_small.2d20f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_send_small.png
// module id = 78
// module chunks = 1